import { configureStore } from "@reduxjs/toolkit";
import { discountSlice } from "./slices/paymentSlice";
import { serviceSlice } from "./slices/serviceSlice";
import { businessSlice } from "./slices/businessSlice";
import { stepsSlice } from "./slices/stepsSlice";
import { teamSlice } from "./slices/teamSlice";
import { userSlice } from "./slices/userSlice";
import { orderSlice } from "./slices/orderSlice";
import {
  appointmentsSettingSlice,
  appointmentsSlice,
} from "./slices/appointmentSlice";
import { reviewSlice } from "./slices/reviewSlice";
import { checkSlice } from "./slices/checkSlice";
import { textChangeSlice } from "./slices/textSlice";

const store = configureStore({
  reducer: {
    discount: discountSlice.reducer,
    service: serviceSlice.reducer,
    business: businessSlice.reducer,
    steps: stepsSlice.reducer,
    team: teamSlice.reducer,
    user: userSlice.reducer,
    order: orderSlice.reducer,
    appointment: appointmentsSlice.reducer,
    appointmentSetting: appointmentsSettingSlice.reducer,
    review: reviewSlice.reducer,
    check: checkSlice.reducer,
    text: textChangeSlice.reducer,
  },
});

export default store;
